import { Provider } from '@angular/core';
import { AbstractTrackingService } from 'shared/core/data-access/analytics-types';

export const provideTrackingService = (
    implementation: typeof AbstractTrackingService,
): Provider => ({
    provide: AbstractTrackingService,
    useExisting: implementation,
});
